import { ActionBtn } from '@/components/Exporter';
import Popup from '@/components/popup';
import { memo, useRef, useState } from 'react';
import { ColumnsGenerator } from '@/utils/tableUtils';
import { GetPatientAttachmentsTypes, GetPatientMedicalAttachments, UploadPatientMedicalAttachment } from '@/api/endpoints';
import { Block } from '@/components/crRender';
import { translate } from '@/utils/langUtils';
import MultiSelect from '@/components/formFields/DropDown/Multiselect';
import './style.css';
import { Icon } from '@iconify/react/dist/iconify.js';
import { DateValue } from '@/components/tableDrawer';
import { LoadListDefault, useGet } from '@/api/hooks';
import UploadPatientMedicalFiles from '@/components/popups/UploadPatientMedicalFiles';
import { defaultFiles } from '../UploadPatientMedicalFiles';
import Table from '@/components/tableDrawer/TableItems/table';
import { TableSkeleton } from '@/components/tableDrawer/TableItems/table/skeleton';

const ViewMedicalFiles = ({ refModal, patientId ,setSelectedPatientId }) => {

    const [sCategory, setsCategory] = useState(null);

    const  {result:medicalFiles ,isPending:isLoading,totalCount}=useGet({
        ...LoadListDefault,
        endPoint: GetPatientMedicalAttachments,
        params: [{patientId,spText: defaultFiles[sCategory?.label]}],
        depArr: [sCategory],
        allowFetch: !!patientId && !!sCategory?.value,
        defaultValue: [],
    })
    

    const  {result:categories}=useGet({
        ...LoadListDefault,
        endPoint: GetPatientAttachmentsTypes,
        params: [],
        depArr: [sCategory],
        subLogic: (data) => {
            setsCategory(data[0])
        },
    })

    const refUploadPatientMedicalFilesModal = useRef(null)

    const columns = [
        ColumnsGenerator.TextCell('name'),
        ColumnsGenerator.TextCell('category'),
        ColumnsGenerator.CustomCell('date', (original) => <DateValue value={original.date} />),
        ColumnsGenerator.CustomCell('action', (original) => (
            <div className="d-flex gap-2 pointer"
                onClick={() => window.open(`${window.API_URL}${original.path}`, '_blank')}
            >
                <Icon icon="fluent:eye-16-filled" width={20} height={20} />
            </div>
        )),
    ];

    const handleUploadPatientMedicalFiles = () => {
        refModal.current?.click()
        refUploadPatientMedicalFilesModal.current?.click()
    }

    return (
        <>
            <Popup
                name="view-medical-files"
                title={translate("medical-files") + " " + "# " + patientId}
                large={true}
                modalID={refModal}
                needbtn={false}
            >
                <Block isRender={!String(patientId)} className="col-12">
                    <div className="alert alert-info">{translate("no-medical-files")}</div>
                </Block>
                <Block isRender={String(patientId)} className="col-12 medical-patient-files">

                    <div className="  title-section">
                        <div>{translate("upload-medical-files")}</div>

                        <div className=' col-lg-6 row action-wrappers'>
                            <MultiSelect options={categories}
                                className='col-lg-6'
                                label={'category'} isMulti={false}
                                viewLabel={false}
                                sOptions={sCategory} setSOptions={setsCategory} />

                            <div className=' add-new-file-btn'>
                                <ActionBtn
                                    onApply={handleUploadPatientMedicalFiles}
                                    icon='gridicons:add'
                                    title={translate("add new file")}
                                    className='add-new-file-btn-action btn py-2' />
                            </div>
                        </div>
                    </div >

                        <Table
                            data={medicalFiles}
                            columns={columns}
                            isPagination={false}
                            isNeedFetch={false}
                            isLoading={isLoading}
                            TotalRows ={totalCount}
                        />
                        <TableSkeleton isLoading={isLoading} />
                </Block>
            </Popup>
            <UploadPatientMedicalFiles setSelectedPatientId={setSelectedPatientId} patientId={patientId} modalID={refUploadPatientMedicalFilesModal} apiCall={(data) => UploadPatientMedicalAttachment({ patientId: data.patientId, attchmentsIds: data.attachmentIds })} />

        </>
    );
};

export default memo(ViewMedicalFiles);